import { useTranslation } from 'react-i18next';
import { SvgArrowLeft } from '../../../icons';
import { classes } from '../../../utils/commonUtils';

import css from './details-button.module.scss';

interface DetailsBackButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export function DetailsBackButton({ className, ...rest }: DetailsBackButtonProps) {
  const { t } = useTranslation();

  return (
    <button className={classes(css.back, className)} {...rest}>
      <SvgArrowLeft width={32} height={32} />
      <span className={css.text}>{t('details:back')}</span>
    </button>
  );
}
